<template>
  
  <div id="quotation-new-message-dialog" class="ui small modal quotation-new-message-modal">

    <div class="ui header">
      Nova Mensagem
    </div>

    <div class="content">

      <form class="ui form" @submit.prevent="onSend()">
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Orçamento</label> 
            <input type="text" :value="quotation ? quotation.id : ''" readonly="readonly">
          </div>
          <div class="twelve wide field">
            <label class="form-label">Remetente</label> 
            <input type="text" :value="$store.state.user.name" readonly="readonly">
          </div>
        </div>        
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Assunto</label>
            <select class="ui fluid dropdown {} " v-model="message.subject">
              <option v-for="subject in subjects" :value="subject.id" :key="subject.id" >{{ subject.value }}</option>
            </select>
          </div>
        </div>  
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Mensagem <span class="red text">*</span></label>
            <textarea id="message-text" rows="6" v-model="message.text"></textarea>
          </div>
        </div>  
      </form>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui blue button" :class="{ loading: sending }" @click="onSend()">
        <i class="check icon"></i>
        Enviar
      </button>
    </div>

  </div>

</template>

<script>

  import { MessageService, QuotationService } from "@/services"
  import { cleanSpecialChars, Message } from "@/utils"

  export default {
    
    data() {
      return {
        sending: false,     
        subjects: [], 
        message: {          
          subject: "",
          text: "",
        },        
      }
    },

    props: ["quotation"],

    created() {
      const user = this.$store.state.user
      this.loadFiles()
      if (user.isApprover) {
        this.message.subject = "08"
      }
    },

    beforeDestroy() {
      $(".quotation-new-message-modal").remove()
    },

    methods: {

      show() {
        $("#quotation-new-message-dialog").modal("show")
      },

      hide() {
        $("#quotation-new-message-dialog").modal("hide")
      },

      async loadFiles() {
        try {

          if (!this.subjects.length) {
            this.subjects = await QuotationService.getSubjectsCategories()     
          }
        } catch (error) {
          this.$errorHandler(error, { silent: true })
        }
      },

      async onSend() {

        if (!this.message.subject) {
          Message.info("Informe o assunto da mensagem")
          return
        }
        
        if (!this.message.text) {
          Message.info("Informe o texto da mensagem")
          return
        }

        this.sending = true

        try {

          this.message.subject = cleanSpecialChars(this.message.subject)
          this.message.text = cleanSpecialChars(this.message.text)
          this.message.text = this.message.text.replace(/(\r\n|\n|\r)/gm, "<br/>")          

          await MessageService.create({ quotationId: this.quotation.id, ...this.message })

          this.hide()
          
          this.message = {
            subject: "",
            text: "",
          }

          this.sending = false

          this.$emit("onSendMessage")

          Message.success("Mensagem enviada com sucesso")          
          
        } catch (error) {
          
          this.sending = false
          this.$errorHandler(error)
        }  
      },
    },
  }

</script>
